module.exports = __webpack_public_path__ + "static/media/Mantine_gaussian2.bbbd4b63.png";